import pluralize from 'pluralize';

angular.module('shared').factory('restangularInterceptors', ["$window", function($window) {
  return {
    RequestInterceptor: function(element, operation, route) {
      var data, name, wrappedElement;
      data = angular.copy(element);
      if (operation === 'post' || operation === 'put') {
        if (!data.withoutNamespace) {
          wrappedElement = {};
          name = data.rootObjectName || pluralize.singular(route);
          data.rootObjectName = void 0;
          wrappedElement[name] = data;
          data = wrappedElement;
        }
        data.withoutNamespace = void 0;
      }
      return data;
    },
    ResponseInterceptor: function(data, operation, what, url) {
      var collection, collectionName, modelName;
      if (data.kiosk_mode) {
        $window.location.reload();
      }
      if (operation === 'getList') {
        if (_.isArray(data)) {
          if (!data.meta) {
            data.meta = {};
          }
        } else {
          collectionName = '';
          collection = _.find(data, function(value, key) {
            if (_.isArray(value)) {
              collectionName = key;
              return value;
            }
          });
          if (collectionName) {
            collection.meta = angular.extend(_.omit(data, [collectionName, 'meta']), data != null ? data.meta : void 0);
            data = collection;
          } else {
            data = [];
            data.meta = {};
            data;
          }
        }
      }
      if (operation === 'get') {
        modelName = pluralize.singular(url.split('/').reverse()[1]);
        if (data[modelName]) {
          data = data[modelName];
        }
      }
      return data;
    }
  };
}]);
